const BOXSHADOWS = {
  BOXSHADOW_L1: '0px 2px 4px rgba(0, 0, 0, 0.15)',
  BOXSHADOW_L2: '0px 4px 8px rgba(0, 0, 0, 0.15)',
  BOXSHADOW_L3: '0px 8px 16px rgba(0, 0, 0, 0.15)',
  BOXSHADOW_CENTERED:
    '0px 4px 10px rgba(0, 0, 0, 0.15), 0px 0px 6px rgba(0, 0, 0, 0.15)',
} as const;

export { BOXSHADOWS };
